import React from 'react';

/** Severity -> ring colour. Only major/urgent render a ring — cosmetic and
 *  minor stay ring-less so the plan doesn't get visually noisy for everyday
 *  defects. Returns null when no ring should render.
 */
export function severityRingColor(severity) {
    if (severity === 'major') return '#F59E0B';  // amber
    if (severity === 'urgent') return '#991B1B'; // dark maroon (distinct from rejected red #E53935)
    return null;
}

/** Floorplan pin marker — shows an outlined circle with the pin number.
 *  Uses plain CSS borders so it renders identically in the app, the share
 *  link, and (crucially) the print-to-PDF output where complex clipPaths
 *  get stripped by some browsers.
 */
export default function PinMarker({ number, status, builderResponse, severity, testId }) {
    // Completed wins over rejected (homeowner has marked it done after dispute);
    // rejected = builder pushed back; otherwise outstanding/cyan.
    const color = status === 'completed'
        ? '#00875A'
        : builderResponse === 'rejected'
            ? '#E53935'
            : '#1FA5CF';
    const ring = severityRingColor(severity);
    // Combine pin-tail shadow with optional outer severity ring.
    const shadows = [`0 2px 0 -1px ${color}`];
    if (ring) shadows.push(`0 0 0 2px ${ring}`);
    return (
        <span
            className="relative inline-flex items-center justify-center w-8 h-8 pin-marker"
            data-testid={testId}
            style={{
                border: `2px solid ${color}`,
                borderRadius: '9999px',
                background: '#FFFFFF',
                color,
                fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
                fontWeight: 700,
                fontSize: '12px',
                lineHeight: 1,
                boxShadow: shadows.join(', '),
            }}
        >
            {number || '•'}
        </span>
    );
}
